var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPhone({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 17.975,
    height: 10.964,
    viewBox: "0 0 17.975 10.964",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_16052",
    "data-name": "Group 16052",
    transform: "translate(-802.025 -609.437)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1108",
    "data-name": "Path 1108",
    d: "M4.978,19.5H.738a.738.738,0,1,0,0,1.475h4.24a.738.738,0,1,0,0-1.475Z",
    transform: "translate(802.025 589.937)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1109",
    "data-name": "Path 1109",
    d: "M17.622,58.8H16.153a.738.738,0,1,0,0,1.475h1.469a.738.738,0,1,0,0-1.475Z",
    transform: "translate(789.381 557.697)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1110",
    "data-name": "Path 1110",
    d: "M10.725,39.151H7.745a.738.738,0,1,0,0,1.476h2.98a.738.738,0,0,0,0-1.476Z",
    transform: "translate(796.277 573.817)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1111",
    "data-name": "Path 1111",
    d: "M48.593,19.5H40.123a1.259,1.259,0,0,0-1.259,1.259V26.78a1.259,1.259,0,0,0,1.259,1.259H42.3V29.96a.5.5,0,0,0,.86.356l2.277-2.277h3.16a1.259,1.259,0,0,0,1.259-1.259V20.759A1.259,1.259,0,0,0,48.593,19.5Z",
    transform: "translate(770.148 589.937)",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhone);
export default __webpack_public_path__ + "static/media/phone.5fb02b4ef44030938385114f40d2501f.svg";
export { ForwardRef as ReactComponent };